import React from 'react';
import PollView from '../../../PollView';
// TODO: merge PollView into this
export const PollFullView = ({ deviation })=>{
    return /*#__PURE__*/ React.createElement(PollView, {
        deviation: deviation
    });
};
PollFullView.displayName = 'PollFullView';
export default PollFullView;
